export default "__VITE_ASSET__CY$PI58I__"